// extracted by mini-css-extract-plugin
module.exports = {"MainWeatherWrapper":"MainWeather_MainWeatherWrapper__3S4nL","WeatherWrapper":"MainWeather_WeatherWrapper__1BR3m"};